







































































































































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import CAddModal from '@/modules/budget-request/budget-gkkp/c-add-modal.vue';
import CNumberInput from '@/components/c-number-input/index.vue';
import store from '@/services/store';

@Component({
    name: 'c-limit-gu',
    components: {
        'c-add-modal': CAddModal,
        'c-number-input': CNumberInput
    }
})
export default class CGuLimit extends Vue {

    @Prop({
        required: true,
        default: null
    })
    private curAbpProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curVariantProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curPeriodProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private dataTypeProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curRegionProp!: any | null;

    @Prop({
        required: false,
        default: null
    })
    private variantEndDateProp!: any | null; // дата окончания варианта, для ограничения справочников по датам версий

    @Prop({
        required: true,
        default: false
    })
    private editableProp!: boolean;

    private get editable() {
        return this.editableProp;
    }

    private progress = 0;
    private collapseAll = false;

    private curAbp: any | null = null;
    private curVariant: any | null = null;
    private curYear: number | null = null;
    private dataType: any | null = null;
    private curRegion: any | null = null;
    private variantEndDate: string | null = null;

    // -- список программ
    private progBase: any[] = [];
    private curIndxPrg: number | null = null; // программа к которой добавляется ГУ и подпрограмма
    private curIndxPpr: number | null = null; // подпрограмма к которой добавляется ГУ
    private guBase: any[] = [];
    // --параметры для модального добавления
    private nameDict = 'программы';
    private codeDict = 'prg';

    // ----
    private totalSum: any = { value1: 0, value2: 0, value3: 0 };
    private totalLimit: any = { value1: null, value2: null, value3: null };

    private dataLst: any [] = [];

    private checkedAll = false;

    /**
     * изменение фильтра
     * @param params
     */
    public chgEvent(params: any) {
        this.curAbp = params.curAbp;
        this.curVariant = params.curVariant;
        this.curYear = params.curYear;
        this.dataType = params.dataType;
        this.curRegion = params.regionProp;
        this.variantEndDate = params.variantEndDate;
        this.loadAll();
    }

    private mounted() {
        this.curAbp = this.curAbpProp;
        this.curVariant = this.curVariantProp;
        if (this.curPeriodProp) { this.curYear = this.curPeriodProp.year; }
        this.dataType = this.dataTypeProp;
        this.curRegion = this.curRegionProp;
        this.variantEndDate = this.variantEndDateProp;
        this.loadAll();
    }

    private async loadAll() {
        this.loadGuLst();
        this.loadData();
        this.loadProgLst();
    }

    /**
     * загрузка данных
     */
    private async loadData() {
        this.totalSum = { value1: 0, value2: 0, value3: 0 };
        this.totalLimit = { value1: null, value2: null, value3: null };
        this.dataLst = [];
        if (!this.curAbp || !this.curVariant || !this.curYear || !this.dataType || !this.curRegion) {
            return;
        }
        this.progress = 50;
        const params = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, dataType: this.dataType.code, region: this.curRegion.code, date_b: this.curVariant.date_start, date_e: this.variantEndDate };
        this.loadTotalLimit(params);
        this.dataLst = await this.loadSavedData(params);
        this.progress = 80;
        if (!this.dataLst.length)  { this.dataLst = await this.loadFirstData(params); }
        this.progress = 100;
    }


    private async loadProgLst() {
        if (!this.curAbp) { return; }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-dict-func-childs-by-parent-code/${encodeURI(JSON.stringify({type: 4, abp: this.curAbp.abp}))}`);
            response = await response.json();
            this.progBase = response;
            // if (this.progDevelopType !== null) { response = response.filter((item: any) => item.develop_type === 0); }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки программ', (error as Error).toString());
        }
    }

    private async loadGuLst() {
        if (!this.curAbp || !this.curRegion) { return; }
        let response: any = [];
        try {
            response = await fetch(`/api-py/dict-gu-by-region-abp/${this.curRegion.code}/${this.curAbp.abp}`);
            response = await response.json();
            this.guBase = response;
            // if (this.progDevelopType !== null) { response = response.filter((item: any) => item.develop_type === 0); }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки ГУ', (error as Error).toString());
        }
    }

    /**
     * загрузка всего лимита
     */
    private async loadTotalLimit(params: any) {
        const url = `/api-py/get-budget-gkkp-limit-gu-total/${encodeURI(JSON.stringify(params))}`;
            let response: any = [];
            try {
                response = await fetch(url);
                if (response.status === 200) {
                    response = await response.json();
                    for (let i=1; i<4; i++) {
                        if (response[`value${i}`] === undefined) {
                            response[`value${i}`] = null;
                        } else {
                            response[`value${i}`] = this.fixNegativeZero(Math.round(response[`value${i}`]*10) / 10);
                        }
                    }
                    this.totalLimit = response;
                } else {
                    makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu-total', `${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                response = [];
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu-total', (error as Error).toString());
            }
    }

    // убрать -0
    private fixNegativeZero(val: number) {
        const result = Math.round(val*100)/100;
        return result == 0? 0: result;
    }

    /**
     * загрузка сохранённых данных из budget_limit_gu
     * @param params параметры
     */
     private async loadSavedData(params: any) {
        const url = `/api-py/get-budget-gkkp-limit-gu/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu', (error as Error).toString());
        }
        return this.getSavedData(response);
    }

    /**
     * сформировать данные из loadSavedData
     * @param response
     */
    private getSavedData(response: any[]) {
        const result: any[] = [];
        response.sort((a: any, b: any) => (a.prg.prg > b.prg.prg) ? 1 : -1);
        for (const el of response) {
            // Находим или создаем группу по программе
            let prgGroup = result.find(group => group.prg.prg === el.prg.prg);
            if (!prgGroup) {
                prgGroup = {
                    prg: el.prg,
                    pprLst: [],
                    sumVl1: 0,
                    sumVl2: 0,
                    sumVl3: 0,
                    plan: 0,
                    value1: 0,
                    value2: 0,
                    value3: 0,
                    proc1: 0,
                    proc2: 0,
                    proc3: 0,
                    collapse: this.collapseAll,
                    checked: this.checkedAll
                };
                result.push(prgGroup);
            }

            // Находим или создаем группу по ppr внутри программы
            let pprGroup = prgGroup.pprLst.find((p: any) => p.ppr.ppr === el.ppr.ppr);
            if (!pprGroup) {
                pprGroup = {
                    ppr: el.ppr,
                    guLst: [],
                    sumVl1: el.sum_vl1,
                    sumVl2: el.sum_vl2,
                    sumVl3: el.sum_vl3,
                    plan: 0,
                    value1: 0,
                    value2: 0,
                    value3: 0,
                    proc1: 0,
                    proc2: 0,
                    proc3: 0,
                    collapse: this.collapseAll,
                    checked: this.checkedAll
                };
                for (let i = 1; i < 4; i++) { prgGroup[`sumVl${i}`] += pprGroup[`sumVl${i}`] };
                prgGroup.pprLst.push(pprGroup);
            }

            // Обрабатываем элемент и добавляем в guLst
            const obj = Object.assign({ proc1: 0, proc2: 0, proc3: 0, checked: this.checkedAll }, el);
            for (let i = 1; i < 4; i++) {
                pprGroup[`value${i}`] += obj[`value${i}`];
                prgGroup[`value${i}`] += obj[`value${i}`];
                this.totalSum[`value${i}`] += obj[`value${i}`];
            }

            // Вычисляем проценты
            if (obj.plan) {
                obj.proc1 = Math.round(obj.value1 / obj.plan * 1000) / 10;
            }
            for (let i = 2; i < 4; i++) {
                if (obj[`value${i-1}`]) {
                    obj[`proc${i}`] = Math.round(obj[`value${i}`] / obj[`value${i-1}`] * 1000) / 10;
                }
            }

            this.calcProc(obj, pprGroup);
            this.calcProc(obj, prgGroup);

            delete obj.prg;
            delete obj.ppr;
            pprGroup.guLst.push(obj);
        }
        for (const prgGroup of result) {
            prgGroup.pprLst.sort((a: any, b: any) => a.ppr.ppr - b.ppr.ppr);
            if (prgGroup.pprLst.length && prgGroup.pprLst[0].ppr.ppr === null) { prgGroup.pprExists = false; }
            for (const pprGroup of prgGroup.pprLst) {
                pprGroup.guLst.sort((a: any, b: any) => a.gu.gu - b.gu.gu);
            }
        }
        return result;
    }

    private calcProc(obj: any, group: any) {
        group.plan += (obj.plan ? obj.plan : 0);

        if (group.plan) {
            group.proc1 = Math.round(group.value1 / group.plan * 1000) / 10;
        }
        if (group.value1) {
            group.proc2 = Math.round(group.value2 / group.value1 * 1000) / 10;
        }
        if (group.value2) {
            group.proc3 = Math.round(group.value3 / group.value2 * 1000) / 10;
        }
    }



    /**
    *Загрузка первичных данных
    */
    private async loadFirstData(params: any) {
        const url = `/api-py/get-budget-gkkp-limit-gu-first/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu', (error as Error).toString());
        }
        return await this.getFirstData(response);

    }

    /**
     * сформировать первоначальные данные
     * @param response
    */
    private getFirstData(response: any[]) {
        const result: any[] = [];
        response.sort((a: any, b: any) => (a.prg.prg > b.prg.prg ? 1 : -1));

        for (const el of response) {
            // --- Уровень программы---
            let prgGroup = result.find(group => group.prg.prg === el.prg.prg);
            if (!prgGroup) {
                prgGroup = {
                    prg: el.prg,
                    pprLst: [],
                    sumVl1: 0,
                    sumVl2: 0,
                    sumVl3: 0,
                    plan: 0,
                    value1: 0,
                    value2: 0,
                    value3: 0,
                    proc1: 0,
                    proc2: 0,
                    proc3: 0,
                    collapse: this.collapseAll,
                    checked: this.checkedAll
                };
                if (el.ppr === null || el.ppr.ppr === null) {
                    prgGroup.sumVl1 = el.sum_vl1 || 0;
                    prgGroup.sumVl2 = el.sum_vl2 || 0;
                    prgGroup.sumVl3 = el.sum_vl3 || 0;
                }
                result.push(prgGroup);
            }

            // --- Уровень подпрограммы ---
            let pprGroup: any = null;
            if (el.ppr || (!el.ppr && el.gu)) {
                const elPpr = el.ppr ? el.ppr : { ppr: null, name_ru: null, name_kk: null };
                pprGroup = prgGroup.pprLst.find((p: any) => p.ppr && p.ppr.ppr === elPpr.ppr);
                if (!pprGroup) {
                    pprGroup = {
                        ppr: elPpr,
                        guLst: [],
                        sumVl1: el.sum_vl1 || 0,
                        sumVl2: el.sum_vl2 || 0,
                        sumVl3: el.sum_vl3 || 0,
                        plan: 0,
                        value1: 0,
                        value2: 0,
                        value3: 0,
                        proc1: 0,
                        proc2: 0,
                        proc3: 0,
                        collapse: this.collapseAll,
                        checked: this.checkedAll
                    };
                    for (let i = 1; i < 4; i++) {
                        prgGroup[`sumVl${i}`] += pprGroup[`sumVl${i}`];
                    }
                    prgGroup.pprLst.push(pprGroup);
                }
            }

            // --- Уровень ГУ---
            if (el.gu && pprGroup) {
                const obj = Object.assign(
                    { proc1: 0, proc2: 0, proc3: 0, checked: this.checkedAll },
                    el
                );

                for (let i = 1; i < 4; i++) {
                    pprGroup[`value${i}`] += obj[`value${i}`];
                    prgGroup[`value${i}`] += obj[`value${i}`];
                    this.totalSum[`value${i}`] += obj[`value${i}`];
                }

                if (obj.plan) {
                    obj.proc1 = Math.round(obj.value1 / obj.plan * 1000) / 10;
                }
                for (let i = 2; i < 4; i++) {
                    if (obj[`value${i-1}`]) {
                        obj[`proc${i}`] = Math.round(obj[`value${i}`] / obj[`value${i-1}`] * 1000) / 10;
                    }
                }

                this.calcProc(obj, pprGroup);
                this.calcProc(obj, prgGroup);

                delete obj.prg;
                delete obj.ppr;
                pprGroup.guLst.push(obj);
            }
        }

        // --- сортировка---
        for (const prgGroup of result) {
            this.setExistsPpr(prgGroup);
            prgGroup.pprLst.sort((a: any, b: any) => (a.ppr?.ppr || 0) - (b.ppr?.ppr || 0));
            for (const pprGroup of prgGroup.pprLst) {
                pprGroup.guLst.sort((a: any, b: any) => a.gu.gu - b.gu.gu);
            }
        }
        return result;
    }

    // проставить pprExists, сущетсвует ли ppr для данной программы
    private async setExistsPpr(prgGroup: any) {
        if (prgGroup.pprLst.length === 0) {
            prgGroup.pprExists = false;
            prgGroup.pprLst.push({
                guLst: [], plan: 0, ppr: { ppr: null, name_ru: null, name_kk: null }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll
            });
            return;
        }
        if (prgGroup.pprLst[0].ppr.ppr !== null) { return; }
        // --- группа "без подпрограммы" уже собрана вместе со списком ГУ и суммами - пересоздавать её нельзя,
        // достаточно проставить признак наличия подпрограмм в справочнике.
        // $set - значение приходит после await, когда dataLst уже отрисован
        this.$set(prgGroup, 'pprExists', await this.loadExistsPpr(prgGroup.prg.prg));
        // ---
    }

    /**
     * ввод цифр
     */
    private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }

    /**
     * сворачивать программы
     * @param indx индекс программ
     */
    private clkCollapse(indx: number | null, pprIndx: number | null) {
        if (indx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.dataLst) {
                this.$set(el, 'collapse', this.collapseAll);
            }
        } else {
            let collapse = false;
            if (pprIndx == null) {
                collapse = !this.dataLst[indx].collapse;
                this.$set(this.dataLst[indx], 'collapse', collapse);
            } else {
                collapse = !this.dataLst[indx].pprLst[pprIndx].collapse;
                this.$set(this.dataLst[indx].pprLst[pprIndx], 'collapse', collapse);
            }
            if (this.collapseAll && !collapse) {
                for (const el of this.dataLst) {
                    if (el.collapse) { return; }
                }
                this.collapseAll = false;
            } else if (!this.collapseAll && collapse) {
                for (const el of this.dataLst) {
                    if (!el.collapse) { return; }
                }
                this.collapseAll = true;
            }
        }
    }

    /**
     * изменение значения лимита
     * @param obj объект guLst
     * @param fieldNumber номер поля 1-3
     * @param indx индекс dataLst
     */
    private chgValue(obj: any, fieldNumber: string, indx: number, pprIndx: number) {
        const fieldName = `value${fieldNumber}`
        if (isNaN(obj[fieldName]) || obj[fieldName]==='') { this.$set(obj, fieldName, 0); }
        obj[fieldName] = Math.abs((Math.round(parseFloat(obj[fieldName]) * 10))/10);

        if (obj.plan) { obj.proc1 = Math.round(obj.value1/obj.plan*1000)/10; }
        for (let i = 2; i < 4; i++) {
            if (obj[`value${(i-1)}`]) { obj[`proc${i}`] = Math.round(obj[`value${i}`]/obj[`value${(i-1)}`]*1000)/10; }
        }
        this.calcTotalVal(this.dataLst[indx].pprLst[pprIndx], 'guLst', fieldNumber);
        this.calcTotalVal(this.dataLst[indx], 'pprLst', fieldNumber);
        const totalSum: any = { value1: 0, value2: 0, value3: 0 };
        for (const el of this.dataLst) {
            for (let i=1; i<4; i++) {
                totalSum[`value${i}`] += Math.round(el[`value${i}`]*10)/10;
            }
        }
        this.totalSum = totalSum;
    }

    private calcTotalVal(obj: any, lstName: string, fieldNumber: string) {
        let value1 = 0;
        let value2 = 0;
        let value3 = 0;
        for (const el of obj[lstName]) {
            value1+=el.value1;
            value2+=el.value2;
            value3+=el.value3;
        }
        this.$set(obj, 'value1', Math.round(value1*10)/10);
        this.$set(obj, 'value2', Math.round(value2*10)/10);
        this.$set(obj, 'value3', Math.round(value3*10)/10);
        if (obj.plan) { obj.proc1 = Math.round(obj.value1/obj.plan*1000)/10; }
        for (let i = 2; i < 4; i++) {
            if (obj[`value${(i-1)}`]) { obj[`proc${i}`] = Math.round(obj[`value${i}`]/obj[`value${(i-1)}`]*1000)/10; }
        }
    }

    private addGu(indx: number, pprIndx: number) {
        const dictLst = [];
        this.nameDict = 'ГУ';
        this.codeDict = 'code';
        for (const el of this.guBase) {
            let fl = false;
            for (let i = 0; i < this.dataLst[indx].pprLst[pprIndx].guLst.length; i++) {
                if (this.dataLst[indx].pprLst[pprIndx].guLst[i].gu.gu === el.code) {
                    fl = true;
                    break;
                }
            }
            if (!fl) { dictLst.push(el); }
        }
        this.curIndxPrg = indx;
        this.curIndxPpr = pprIndx;

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.openModal(dictLst);
    }

    /**
     * добавить программу
     */
    private addProg() {
        const dictLst = [];
        this.nameDict = 'программы';
        this.codeDict = 'prg';
        for (const el of this.progBase) {
            let fl = false;
            for (let i = 0; i < this.dataLst.length; i++) {
                if (this.dataLst[i].prg.prg === el.prg) {
                    fl = true;
                    break;
                }
            }
            if (!fl) { dictLst.push(el); }
        }

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.openModal(dictLst);
    }

    /**
     * добавить подпрограмму
     */
    private addSubProg(indx: number) {
        this.nameDict = 'подпрограммы';
        this.codeDict = 'ppr';
        this.curIndxPrg = indx;
        const data = this.dataLst[indx];
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.loadSubProgLst(this.curAbp, data.prg, data.pprLst);
    }

    private async loadExistsPpr(prg: number) {
        if (!this.curAbp) { return null; }
        const elBase = this.progBase.find((item: any) => item.prg === prg);
        if (!elBase) { return null; }
        if (elBase.pprExists!==undefined && elBase.pprExists!==null) { return elBase.pprExists; }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-dict-func-subprog-exists/${encodeURI(JSON.stringify({abp: this.curAbp.abp, prg: prg}))}`);
            response = await response.json();
            elBase.pprExists = response.pprExists;
            return response.pprExists;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки программ', (error as Error).toString());
            return null
        }
    }

    /**
     * кнопка добавить с модального окна
     */
    private async addModalClk(items: any[]) {
        if (this.codeDict === 'prg') { // добавление программ
            for (const el of items) {
                if (el.pprExists === undefined || el.pprExists === null) {
                    el.pprExists = await this.loadExistsPpr(el.prg);
                }
                const pprLst: any[] = [];
                if (el.pprExists === false) {
                    pprLst.push({ guLst: [], plan: 0, ppr: { ppr: null, name_ru: null, name_kk: null }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll });
                }
                const obj = { pprLst: pprLst, plan: 0, pprExists: el.pprExists, prg: { prg: el.prg, name_ru: el.name_ru, name_kk: el.name_kk }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll };
                if (el.pprExists === false) { this.loadProgValSum(el.prg, obj); }
                this.dataLst.push(obj);
            }
            this.dataLst.sort((a: any, b: any) => (a.prg.prg > b.prg.prg) ? 1 : -1);
        } else if (this.codeDict === 'ppr') { // добавление подпрограмм
            if (this.curIndxPrg === null) { return; }
            for (const el of items) {
                const obj = { guLst: [], plan: 0, ppr: { ppr: el.ppr, name_ru: el.name_ru, name_kk: el.name_kk }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll }
                this.dataLst[this.curIndxPrg].pprLst.push(obj);
            }
            this.dataLst[this.curIndxPrg].pprLst.sort((a: any, b: any) => (a.ppr.ppr > b.ppr.ppr) ? 1 : -1);
            this.loadSubProgValSum(items);
        } else { // добавление ГУ
            if (this.curIndxPrg === null || this.curIndxPpr === null) { return; }
            const curPrg = this.dataLst[this.curIndxPrg].prg.prg
            const curPprEl = this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr];
            const curPpr = curPprEl.ppr ? curPprEl.ppr.ppr : null; // null - у программы нет подпрограмм
            const params: any = {prg: curPrg, ppr: curPpr, guLst: [], curYear: this.curYear, abp: this.curAbp.abp, variant: this.curVariant.variant_uuid};
            for (const el of items) {
                params.guLst.push(el.code);
            }
            const url = `/api-py/get-budget-gkkp-limit-gu-plan/${encodeURI(JSON.stringify(params))}`;
            let response: any = [];
            try {
                response = await fetch(url);
                if (response.status === 200) {
                    response = await response.json();
                } else {
                    makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu-plan', `${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                response = [];
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-gu-plan', (error as Error).toString());
            }
            let sumPlan = 0;
            for (const el of items) {
                const obj = {gu: { gu: el.code, name_ru: el.name_ru, name_kk: el.name_kk }, plan: 0, proc1: 0, proc2: 0, proc3: 0, value1: 0, value2: 0, value3: 0, checked: this.checkedAll};
                for (let i = 0; i < response.length; i++) {
                    if (response[i].gu === el.code) {
                        obj.plan = response[i].plan;
                        sumPlan += obj.plan;
                        break;
                    }
                }
                this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr].guLst.push(obj);
            }
            const sumPlanPrg = Math.round((sumPlan + this.dataLst[this.curIndxPrg].plan)*10)/10;
            const sumPlanPpr = Math.round((sumPlan + this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr].plan)*10)/10;
            this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr].guLst.sort((a: any, b: any) => (a.gu.gu > b.gu.gu) ? 1 : -1);
            this.$set(this.dataLst[this.curIndxPrg], 'plan', sumPlanPrg);
            this.$set(this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr], 'plan', sumPlanPpr);
        }
    }

    /**
      * подгрузка суммы лимитов для подпрограмм из budget_cost_data
      */
    private async loadSubProgValSum(items: any[]) {
        if (!this.curAbp || !this.curVariant || !this.curYear  || !this.curRegion || !this.dataType || !items.length) {
            return;
        }

        const params: any = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, pprLst: [], prg: items[0].prg, region: this.curRegion.code, dataType: this.dataType.code };
        for (const item of items) {
            params.pprLst.push(item.ppr);
        }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-budget-gu-limit-prog-sum-by-subprog/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                response = await response.json();
                this.setPprValSum(response, items[0].prg);
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gu-limit-prog-sum-by-subprog', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gu-limit-prog-sum-by-subprog', (error as Error).toString());
        }
    }

    /**
      * подгрузка суммы лимитов для программ из budget_cost_data
      */
      private async loadProgValSum(prg: number, prgObj: any) {
        if (!this.curAbp || !this.curVariant || !this.curYear  || !this.curRegion || !this.dataType) {
            return null;
        }

        const params: any = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, prg: prg, region: this.curRegion.code, dataType: this.dataType.code };
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-budget-gu-limit-prog-sum-by-prog/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                response = await response.json();
                prgObj.sumVl1 = response.sum_vl1 || 0;
                prgObj.sumVl2 = response.sum_vl2 || 0;
                prgObj.sumVl3 = response.sum_vl3 || 0;
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gu-limit-prog-sum-by-prog', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gu-limit-prog-sum-by-prog', (error as Error).toString());
            return;
        }
    }

    /**
     * проставить суммы лимитов для подпрограмм из budget_limit_gu
     * @param response
     */
     private setPprValSum(response: any[], prg: number) {
        const prgObj = this.dataLst.find((p: any) => p.prg.prg === prg);
        const sumVlprog: any = {sumVl1: prgObj.sumVl1, sumVl2: prgObj.sumVl2, sumVl3: prgObj.sumVl3};
        for (const el of response) {
            for (let i = 0; i < prgObj.pprLst.length; i++) {
                if (prgObj.pprLst[i].ppr.ppr === el.ppr) {
                    for (let j = 1; j < 4; j++) {
                        this.$set(prgObj.pprLst[i], `sumVl${j}`, el[`sum_vl${j}`]);
                        if (el[`sum_vl${j}`]) { sumVlprog[`sumVl${j}`] += el[`sum_vl${j}`]; }
                    }
                    break;
                }
            }
            for (let j = 1; j < 4; j++) {
                this.$set(prgObj, `sumVl${j}`, sumVlprog[`sumVl${j}`]);
            }
        }
    }

    /**
     *  сохранить
     */
    private async saveClk() {
        if (!this.editable) { return; }
        if (this.progress > 0 && this.progress < 100) { return; }

        if (this.totalLimit && this.totalSum && this.dataLst.length) {
            for (let i=1; i<4; i++) {
                if (this.totalLimit[`value${i}`]===null) {
                    if (this.totalSum[`value${i}`]) {
                        makeToast(this, 'danger', 'Сохранение', 'Сохранение не возможно, так как не определены общие лимиты по АБП (строка ВСЕГО ЛИМИТ не заполнена)');
                        return;
                    }
                } else if ((this.fixNegativeZero(this.totalLimit[`value${i}`] - this.totalSum[`value${i}`])) < 0) {
                    makeToast(this, 'danger', 'Сохранение', 'Остаток по лимиту не может быть отрицательным. Проверьте данные!');
                    return;
                 }
            }
        }
        const saveObj: any = { variant: this.curVariant.variant_uuid, abp: this.curAbp.abp, curYear: this.curYear, usrId: store.state.user.sub, valueLst: [] };
        for (const el of this.dataLst) {
            for (const pprEl of el.pprLst) {
                for (const guEl of pprEl.guLst) {
                    if (guEl.value1 || guEl.value2 || guEl.value3) {
                        if (guEl.value1 < 0 || guEl.value2 < 0 || guEl.value3 < 0) {
                            makeToast(this, 'danger', 'Ошибка сохранения', 'Ввод отрицательных чисел запрещен!');
                            return;
                        }
                        const obj = { gu: guEl.gu.gu, prg: el.prg.prg, ppr: pprEl.ppr.ppr, value1: guEl.value1, value2: guEl.value2, value3: guEl.value3 };
                        saveObj.valueLst.push(obj);
                    }
                }
            }
        }

        try {
            const url = '/api-py/budget-gkkp-limit-gu-save';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            for (const el of response) {
                if (el.result !== 'success') {
                    makeToast(this, 'danger', 'Ошибка сохранения', el.result);
                    return;
                }
            }
            makeToast(this, 'success', 'Сообщение', 'Данные сохранены');

        } catch (error) {
            makeToast(this, 'danger', 'Ошибка сохранения', (error as Error).toString());
        }
    }

    /**
     * изменение checkbox
     * @param prgIndx
     * @param guIndx
     */
    private clkCheck(prgIndx: number | null, pprIndx: number | null, guIndx: number | null) {
        if (prgIndx === null) {
            for (const el of this.dataLst) {
                this.$set(el, 'checked', this.checkedAll);
                for (const pprEl of el.pprLst) {
                    this.$set(pprEl, 'checked', this.checkedAll);
                    for (const elGu of pprEl.guLst) {
                        this.$set(elGu, 'checked', this.checkedAll);
                    }
                }
            }
            return;
        }
        let checked = false;
        if (pprIndx === null) {
            checked = this.dataLst[prgIndx].checked;
            for (const pprEl of this.dataLst[prgIndx].pprLst) {
                this.$set(pprEl, 'checked', checked);
                for (const elGu of pprEl.guLst) {
                    this.$set(elGu, 'checked', checked);
                }
            }
        } else {
            if (guIndx === null) {
                checked = this.dataLst[prgIndx].pprLst[pprIndx].checked;
                for (const guEl of this.dataLst[prgIndx].pprLst[pprIndx].guLst) {
                    this.$set(guEl, 'checked', checked);
                }
            } else {
                checked = this.dataLst[prgIndx].pprLst[pprIndx].guLst[guIndx].checked;
                if (this.dataLst[prgIndx].pprLst[pprIndx].checked && !checked) {
                    this.dataLst[prgIndx].pprLst[pprIndx].checked = false;
                } else if (!this.dataLst[prgIndx].pprLst[pprIndx].checked && checked) {
                    this.dataLst[prgIndx].pprLst[pprIndx].checked = this.dataLst[prgIndx].pprLst[pprIndx].guLst.every((item: any) => item.checked);
                }
            }
            if (!checked && this.dataLst[prgIndx].checked) {
                this.dataLst[prgIndx].checked = false;
            } else if (!this.dataLst[prgIndx].checked && checked) {
                this.dataLst[prgIndx].checked = this.dataLst[prgIndx].pprLst.every((item: any) => item.checked);
            }
        }
        if (this.checkedAll && !checked) {
            this.checkedAll = false;
        } else if (!this.checkedAll && checked) {
            this.checkedAll = this.dataLst.every((item: any) => item.checked);
        }
    }

    /**
     * удалить отмеченные
     */
    private delSelected() {
        let fl = false;
        for (let i = 0; i < this.dataLst.length; i++) {
            if (i < 0) { break; }
            if (this.dataLst[i].checked) {
                this.delRow(i, null, null);
                fl = true;
                i--;
            } else {
                for (let j = 0; j < this.dataLst[i].pprLst.length; j++) {
                    if (j < 0) {break;}
                    if (this.dataLst[i].pprLst[j].checked) {
                        this.delRow(i, j, null);
                        fl = true;
                        j--;
                    } else {
                        for (let k = 0; k < this.dataLst[i].pprLst[j].guLst.length; k++){
                            if (k < 0) { break; }
                            if (this.dataLst[i].pprLst[j].guLst[k].checked) {
                                this.delRow(i, j, k);
                                fl = true;
                                k--;
                            }
                        }
                    }
                }
            }
        }
        if (!fl) {
            makeToast(this, 'warning', 'Удаление', 'Нет отмеченных строк');
        }
    }

    /**
     * удалить строку
     * @param prgIndx индекс программы
     * @param guIndx индекс gu
     */
    private delRow(prgIndx: number, pprIndx: number | null, guIndx: number | null) {
        if (pprIndx === null) {
            for (let i=1; i < 4; i++) {
                this.totalSum[`value${i}`] -=this.dataLst[prgIndx][`value${i}`];
            }
            this.dataLst.splice(prgIndx, 1);
        } else if (guIndx === null) {
            const pprEl = this.dataLst[prgIndx].pprLst[pprIndx];
            this.dataLst[prgIndx].plan -= pprEl.plan;
            for (let i = 1; i < 4; i++) {
                this.dataLst[prgIndx][`value${i}`] -= pprEl[`value${i}`];
                this.totalSum[`value${i}`] -= pprEl[`value${i}`];
            }

            this.dataLst[prgIndx].pprLst.splice(pprIndx, 1);
        } else {
            const guEl = this.dataLst[prgIndx].pprLst[pprIndx].guLst[guIndx];
            this.dataLst[prgIndx].plan -= guEl.plan;
            this.dataLst[prgIndx].pprLst[pprIndx].plan -= guEl.plan;
            for (let i = 1; i < 4; i++) {
                this.dataLst[prgIndx][`value${i}`] -= guEl[`value${i}`];
                this.dataLst[prgIndx].pprLst[pprIndx][`value${i}`] -= guEl[`value${i}`];
                this.totalSum[`value${i}`] -= guEl[`value${i}`];
            }
            this.dataLst[prgIndx].pprLst[pprIndx].guLst.splice(guIndx, 1);
        }
    }
}
